/* eslint-disable react/prop-types */
import React from "react";
// import echo from "../../../utils/echo";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";

import { useDispatch } from "react-redux";
import { setTask, toggleModal } from "@/store/task";
import { getTaskById, readNotifications } from "@/utils/task";
import toast from "react-hot-toast";
import { getStatusById } from "@/constants/statusData";
import { useQueryClient } from "@tanstack/react-query";
import { useNotifications } from "../../layout/useNotifications";
import { Card } from "@/components/ui/card";
import { CheckCheck, X } from "lucide-react";


const style = {
    position: "absolute",
    maxWidth: "1920px",
    minWidth: "50rem",
    top: "50%",
    right: "0%",
    transform: "translate(-0%, -50%)",
    width: 350,
    bgcolor: "background.paper",
    // pt: 4,
    minHeight: `100vh`,
    maxHeight: "100vh",    
  };
  


function NotificationModal({open, handleClose}) {

    const queryClient = useQueryClient();

    const dispatch = useDispatch();
    
     const  {notifications, isNotificationFetching} = useNotifications();

      const handleOpenTask = async (taskID) => {
            try{
                const task = await getTaskById(taskID);

                dispatch(setTask(task?.data));
                dispatch(toggleModal());

            } catch(err){
                console.log(err?.message);
                if(err instanceof Error) toast.error(err?.message)
            }

      };


      const handleReadNotification = async() => {
        try {
            await readNotifications();
            queryClient.invalidateQueries('notifications');
        }catch(err) {
            console.log(err?.message);
            if(err instanceof Error) toast.error(err?.message)
        }
      }

      if(isNotificationFetching) return ;
      

    return (
        <Modal 
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        >

            <Box style={style} >
                <div className="bg-background py-4 h-screen">
                    {/* header */}
                    <div className="notification_header flex justify-between items-center bg-sidebar px-12">
                        <p className="fs-18 text-foreground  py-4"> Notifications </p>
                        <div className="flex gap-6 items-center">
                            {
                                notifications && notifications?.length > 0 && <div className="cursor-pointer" title="Mark as read" onClick={() => handleReadNotification()}>
                                <CheckCheck className="size-9"  />
                                </div>

                            }
                            
                            <div className="cursor-pointer" onClick={handleClose} title="Close">
                            <X className="size-9"  />
                            </div> 
                        </div>
                    </div>
                    

                    <div className="notification_body px-8 pt-4 pb-8 ">
                       <ul className="space-y-4 h-[calc(100vh-10vh)] overflow-y-auto no-scroll-bar">
                        {
                            notifications && notifications?.length > 0 ?   
                            notifications?.map((notification, index) => <NotificationItem key={index} message={notification?.attributes?.data?.task_name} handleClick={() => handleOpenTask(notification?.attributes?.data?.task_id)}   />)
                            :
                            <p className="fs-13 mt-4   leading-[20px] mb-2"> You have no new notifications.. </p>
                        }
                        
                       </ul>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}


function NotificationItem({message, handleClick}){

    return <li >
        <Card onClick={handleClick} className="px-6 py-2 rounded-3xl" >
        <p className="fs-13 mt-4   leading-[20px] mb-2 cursor-pointer"> 
            <span className="text-foreground/70 flex items-center gap-2">
            <div
                            className="w-[.8rem] h-[1.8rem] rounded-lg inline-block"
                            style={{
                              backgroundColor: `var(${getStatusById(
                              4
                              )?.color
                                })`,
                            }}
                          ></div>
                 New Task Assigned:   </span>
             <span className="text-[1.4rem]"> { message}  </span>
             
              </p>
        </Card>
        
    </li>
}



export default NotificationModal;